export default [
  { href: '/legal/terms', label: 'Terms of Service' },
  { href: '/legal/third-party-terms', label: 'Third Party Terms of Service' },
  { href: '/legal/mobile', label: 'Terms of Service for Mobile App Users' },
  { href: '/legal/privacy', label: 'Privacy & Cookie Statement' },
  { href: '/legal/takedown', label: 'Notice and Takedown Policy' },
  { href: '/legal/disclosure', label: 'Responsible Disclosure Policy' },
  { href: '/legal/advertising', label: 'Advertising Terms &\xa0Conditions' },
];
